import styled from '@emotion/styled';

import { useI18n } from '../../hooks/useI18nFormatters';

import { su } from '../../theme/functions/su';
import { theme } from '../../theme/theme';

export function HiddenDevicesFooter({ hiddenCount, onCustomizePress }) {
  const { i18n } = useI18n();

  if (hiddenCount <= 0) return null;

  return (
    <S.Root>
      <S.Text>
        {i18n.messageFormatter('devices.hiddenDevicesBanner', { count: hiddenCount })}
      </S.Text>
      <S.Separator>&middot;</S.Separator>
      <S.CustomizeButton onClick={onCustomizePress}>
        {i18n.messageFormatter('devices.hiddenDevicesCustomize')}
      </S.CustomizeButton>
    </S.Root>
  );
}

const S = (HiddenDevicesFooter.S = class S {
  static Root = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: ${su(2)} 0;
    gap: ${su(1)};
  `;

  static Text = styled.span`
    font-size: ${theme.fontSize.small};
    color: ${theme.color.text_light};
  `;

  static Separator = styled.span`
    font-size: ${theme.fontSize.small};
    color: ${theme.color.text_light};
  `;

  static CustomizeButton = styled.button`
    font-size: ${theme.fontSize.small};
    color: ${theme.color.highlight};
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    font-weight: ${theme.fontWeight.medium};

    &:hover {
      text-decoration: underline;
    }
  `;
});
